import { createFileRoute } from '@tanstack/react-router';
import ProductOffer from '../../components/InternalPortal/ProductOffer/ProductOffer';
import { PERMISSION_INTERNAL_PORTAL } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/product-offer')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_INTERNAL_PORTAL, ['read'], '/unauthorized', context);

    return {
      ...context,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ProductOfferRoute,
});

function ProductOfferRoute() {
  return <ProductOffer />;
}
